'use es6';

import { Record } from 'immutable';
const CrmCreationSource = Record({
  connectedObjectSourceId: null,
  name: null,
  objectTypeId: null
}, 'CrmCreationSource');
export default CrmCreationSource;